import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../../../components/icon/icon.component';
import { IconButtonBackground, IconButtonComponent } from '../../../components/icon-button/icon-button.component';
import { BreakpointState, Breakpoint, MediaQueryService } from '../../../services/media-query.service';
import { DataAnalyticsService } from '../../../services/data-analytics/data-analytics.service';
import { DataAnalyticsTaggingConstants } from '../../data-analytics-tagging/data-analytics-tagging.constants';
import { TranslatePipe } from '../../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-toolbar-item-refresh',
  templateUrl: 'toolbar-item-refresh.component.html',
  imports: [
    IconComponent,
    IconButtonComponent,
    TranslatePipe,
    AsyncPipe,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarItemRefreshComponent {
  @Input() autoSizeOverride: boolean = true;
  @Input() tdWbIconButtonBackground: IconButtonBackground = 'grey';

  breakpointChanges: Observable<BreakpointState>;

  @Output() readonly onRefresh: EventEmitter<void> = new EventEmitter<void>();

  constructor(private mediaQueryService: MediaQueryService,
              private dataAnalyticsService: DataAnalyticsService) {
    if (this.autoSizeOverride) {
      this.breakpointChanges = this.mediaQueryService.observe(Breakpoint.LT_MD);
    }
  }

  refresh(): void {
    this.dataAnalyticsService.emitEvent(DataAnalyticsTaggingConstants.getLinkClickEventData('tdw:et:refresh'));
    this.onRefresh.emit(null);
  }
}
